import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sc-location-bar',
  styleUrls: ['./location-bar.component.css'],
  templateUrl: './location-bar.component.html'
})
export class LocationBarComponent implements OnInit {
  @Input() public theme: string;
  @Input() public isMenuDeployed: boolean;

  public isHide = false;
  public currentScroll = 0;

  constructor(@Inject(DOCUMENT) private document: any) {}

  public ngOnInit() {}

  @HostListener('window:scroll', [])
  public onWindowScroll() {
    const numberVar = this.document.body.scrollTop;
    if (numberVar > this.currentScroll) {
      this.isHide = true;
    }
    if (numberVar < this.currentScroll) {
      this.isHide = false;
    }
    this.currentScroll = numberVar;
  }
}
